import React from 'react';
import { SvgIcon } from '@material-ui/core';

const DeleteIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 30">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.189 0C10.4058 0 8.14961 2.2562 8.14961 5.03937V5.43307H1.41732C0.634557 5.43307 0 6.06763 0 6.85039C0 7.63316 0.634557 8.26772 1.41732 8.26772H4.0748V24.9606C4.0748 27.7439 6.33102 30 9.11417 30H20.8858C23.6691 30 25.9252 27.7439 25.9252 24.9606V8.26772H28.5827C29.3654 8.26772 30 7.63316 30 6.85039C30 6.06763 29.3654 5.43307 28.5827 5.43307H21.8504V5.03937C21.8504 2.25622 19.5943 0 16.811 0H13.189ZM10.9843 5.43307H19.0158V5.03937C19.0158 3.82172 18.0287 2.83465 16.811 2.83465H13.189C11.9713 2.83465 10.9843 3.82173 10.9843 5.03937V5.43307ZM6.90945 24.9606C6.90945 26.1783 7.89652 27.1654 9.11417 27.1654H20.8858C22.1035 27.1654 23.0906 26.1783 23.0906 24.9606V8.26772H6.90945V24.9606Z"
      />
    </SvgIcon>
  );
};

export default DeleteIcon;
